import { GroupedSummaryDto } from './types';

/**
 * Returns the most recent lastUpdatedAt across all summaries in a grouped response.
 * This represents when the pipeline last ran for this data.
 */
export function getLatestUpdateTime(grouped: GroupedSummaryDto | undefined): string | undefined {
  if (!grouped?.summaries) return undefined;

  const timestamps = Object.values(grouped.summaries)
    .map(s => s.lastUpdatedAt)
    .filter(Boolean)
    .sort();

  return timestamps.length > 0 ? timestamps[timestamps.length - 1] : undefined;
}

/**
 * Formats a UTC ISO timestamp as a short localised date + time string.
 * e.g. "24/03/2026, 11:51"
 */
export function formatFreshnessTimestamp(isoTimestamp: string | undefined): string {
  if (!isoTimestamp) return '';
  const date = new Date(isoTimestamp);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
